<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-edit-song`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 6l-.005-.148a2 2 0 00-2.472-1.794l-22 5.4-.155.044A2 2 0 0014 11.4v19.274A7 7 0 1017.929 38h.072V12.968L36 8.55v11.117h4V6zm5.044 21.657l-4.242-4.243a2 2 0 00-2.829 0L24.522 36.866a2 2 0 00-.586 1.42l.014 4.23a2 2 0 001.993 1.993l4.229.014a2 2 0 001.42-.586l13.452-13.452a2 2 0 000-2.828zm-5.656 0l-11.45 11.449.005 1.41 1.41.004 11.449-11.449-1.414-1.414zM8 37a3 3 0 116 0 3 3 0 01-6 0z"/></svg>
</template>
<script>

export default {
  name: 'IconEditSong',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
